import React from 'react';

const BottomCtaModule = () => {
  return (
    <div className="bg-white px-4 py-3 mx-10 md:mx-36 max-w-3xl mb-10 rounded-xl md:rounded-xl shadow-md md:shadow-2xl shadow-black/10 pb-2">
      <div className="flex flex-col md:flex-row items-center justify-between space-x-6">
        {/* Text Section */}
        <div className="flex-1">
          <h5 className="font-bold text-lg">
          Enjoy a Smarter PTE Preparation Experience with Advanced AI Features
          </h5>
          <div className="mt-3 flex space-x-4">
            <a
              className="px-6 py-2 bg-gradient-to-r from-fuchsia-900 to-fuchsia-700 text-white rounded-lg hover:bg-fuchsia-500"
              href="/pricing"
            >
              Get Premium 
            </a>
          </div>
          <a
            className="text-sm text-fuchsia-600 mt-2 inline-block underline"
            href="/what-is-pte"
          >
            What is a PTE?
          </a>
        </div>

        {/* Image Section */}
        <div className="flex-shrink-0 rounded-lg overflow-hidden py-3">
          <noscript>
            <img
              width="160"
              height="160"
              src="https://s22908.pcdn.co/wp-content/uploads/2021/06/cta-module-phone-protected@2x.png"
              alt="A phone with a padlock."
              className="w-36 h-36 object-cover"
            />
          </noscript>
          <img
            width="160"
            height="160"
            src="https://media.istockphoto.com/id/1367693794/vector/hand-holds-a-mobile-phone-for-play-video.jpg?s=612x612&w=0&k=20&c=FNAoNw2Hf314e2zpEXXCYmlr74U3lB29F2NGHFG7YOU="
            alt="A phone with a padlock."
            className="w-36 h-36 object-cover"
          />
        </div>
      </div>
    </div>
  );
};

export default BottomCtaModule;
